// extracted by mini-css-extract-plugin
module.exports = {"callout":"callout-3iEdg"};